import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout__header" }
const _hoisted_2 = { class: "layout__main" }
const _hoisted_3 = { class: "layout__main-wrapper" }
const _hoisted_4 = { class: "layout__sidebar" }
const _hoisted_5 = { class: "layout__content" }
const _hoisted_6 = { class: "layout__up-button-wrap" }
const _hoisted_7 = { class: "layout__footer" }

import { ref, onMounted, onUnmounted, computed, inject } from 'vue';

import { useMeters } from '@/composables/meters';
import { useRoute } from 'vue-router';

import SmHeader from '@/layouts/SmHeader/SmHeader.vue';
import SmFooter from '@/layouts/SmFooter/SmFooter.vue';
import SmSidebar from '@/layouts/SmSidebar/SmSidebar.vue';
import SmMenuTabBar from '@/components/ui/SmMenuTabBar/SmMenuTabBar.vue';
import SmUpButton from '@/components/ui/SmUpButton/SmUpButton.vue';

import '@/layouts/DefaultLayout/style.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props) {

const showUpButton = ref(false);

const $bus: any = inject('bus');
const $meters = useMeters();
const $route = useRoute();

const className = computed((): string => (
  ($route.meta.pageName) ? `layout--page-${$route.meta.pageName}` : ''
));

const updateButtonVisibility = () => {
  const scrollY = window.scrollY || document.documentElement.scrollTop;
  const hasScroll = document.documentElement.scrollHeight > window.innerHeight;

  showUpButton.value = (hasScroll && scrollY > 100) && $route.name !== 'RequestDetail';
};

$meters
  .fetchList()
  .then(() => {
    $bus.emit('metersIsLoaded');
  })

  onMounted(() => {
  window.addEventListener('scroll', updateButtonVisibility);
  window.addEventListener('resize', updateButtonVisibility);
  updateButtonVisibility();
});

onUnmounted(() => {
  window.removeEventListener('scroll', updateButtonVisibility);
  window.removeEventListener('resize', updateButtonVisibility);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout layout--default", className.value]),
    ref: "layout"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SmHeader)
    ]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("aside", _hoisted_4, [
          _createVNode(SmSidebar)
        ]),
        _createElementVNode("main", _hoisted_5, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createVNode(SmUpButton, null, null, 512), [
        [_vShow, showUpButton.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(SmFooter)
    ]),
    _createVNode(SmMenuTabBar, { class: "layout__tab-bar" })
  ], 2))
}
}

})